import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { ReactComponent as PlusSVG } from '../../assets/img/plus.svg';
import { ModalsList } from '../../constants';
import {
  SubscriptionList,
  SubscriptionHeader,
  SubscriptionContent,
  SubscriptionDivider,
  SubscriptionContainer,
} from '../../components/Subscriptions';
import { useStores } from 'stores';
import styles from './MySubscriptions.module.scss';
import { sortByID } from '../../helpers/utils';
import SubscriptionNotifications from './components/SubscriptionNotofications/SubscriptionNotifications';
import { PrimaryButton } from 'uiKit/atoms/Button/components/PrimaryButton';

const MySubscriptions = ({ title }) => {
  const {
    subscriptionStore: { getSubscriptions },
    singleSubscriptionStore: { cancelSubscription: deleteSubscription },
    modalStore: { showModal },
  } = useStores();

  const navigate = useNavigate();
  const [subscriptions, changeSubscriptions] = useState([]);
  const removeByIndex = value => changeSubscriptions(subscriptions.filter(el => el.id !== value));

  useEffect(() => {
    getSubscriptions().then(res => changeSubscriptions(res?.data));
  }, []);

  // TODO: Previously it was linked to /newSubscription
  const toNewSubscription = () => navigate('/');

  const cancelSubModal = id =>
    showModal(ModalsList.CancelSubscriptionModal.name, () => {
      deleteSubscription(id);
      removeByIndex(id);
    });

  return (
    <SubscriptionContainer>
      <SubscriptionHeader title={title}>
        <PrimaryButton variant="none" onClick={toNewSubscription}>
          <div className={styles.bns3_mySubscriptionsButton}>
            <PlusSVG className={styles.bns3_mySubscriptionsIcon} />
            <span>add new subscription</span>
          </div>
        </PrimaryButton>
      </SubscriptionHeader>

      <SubscriptionContent>
        <div className={styles.bns3_mySubscriptions}>
          <div className={styles.bns3_subscriptionsTitle}>active subscriptions</div>
          <div className={styles.bns3_SubscriptionList}>
            <SubscriptionList subscriptions={sortByID(subscriptions)} cancelSubscription={cancelSubModal} />
          </div>
        </div>
        <SubscriptionDivider />
        <SubscriptionNotifications />
      </SubscriptionContent>
    </SubscriptionContainer>
  );
};

MySubscriptions.displayName = 'MySubscriptions';

MySubscriptions.propTypes = {
  title: PropTypes.string.isRequired,
  subscriptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
    })
  ),
  getSubscriptions: PropTypes.func,
  deleteSubscription: PropTypes.func,
  showModal: PropTypes.func,
};

export default observer(MySubscriptions);
